import { html, View } from 'rune-ts';

export type ResultSummaryData = {
  winnerNickname: string;
  isMe: boolean;
};

const TAUNTS = [
  '이게 최선인가요?',
  '한 끗 차이라고 위로하지 마세요',
  '다시 도전… 할 수 있겠어요?',
  '아쉽다고요? 진 건 진 거예요',
  '운이 없었던 게 아니라 실력입니다',
  '이번엔 정말 안됐네요',
  '연습이 부족했군요',
  '핑계 댈 자리는 없어요',
] as const;

function pickTaunt(): string {
  return TAUNTS[Math.floor(Math.random() * TAUNTS.length)] ?? TAUNTS[0];
}

export class ResultSummaryView extends View<ResultSummaryData> {
  override template() {
    const { winnerNickname, isMe } = this.data;
    if (isMe) {
      return html`
        <section
          class="result-summary flex flex-col items-center gap-3 rounded-2xl bg-card-gold/15 ring-2 ring-card-gold p-6 text-center w-full"
        >
          <div class="trophy-pop text-6xl sm:text-7xl drop-shadow" aria-hidden="true">🏆</div>
          <h1 class="text-4xl font-extrabold text-card-brass tracking-tight">승리!</h1>
          <p class="text-wood-coffee">22장 모두 공개에 성공했습니다</p>
        </section>
      `;
    }
    const taunt = pickTaunt();
    return html`
      <section
        class="result-summary defeat-shake relative overflow-hidden flex flex-col items-center gap-3 rounded-2xl bg-gradient-to-b from-rose-900/40 to-wood-coffee/60 ring-2 ring-rose-600 p-6 text-center w-full shadow-[0_0_24px_rgba(225,29,72,0.35)]"
      >
        <div class="text-6xl sm:text-7xl drop-shadow" aria-hidden="true">💀</div>
        <h1
          class="defeat-slam text-5xl sm:text-6xl font-black text-rose-400 tracking-tight uppercase"
        >
          DEFEAT
        </h1>
        <p class="text-base text-rose-100/90 font-semibold">
          <strong class="text-card-gold">${winnerNickname}</strong>에게 졌습니다
        </p>
        <p class="text-sm text-rose-200/80 italic">"${taunt}"</p>
      </section>
    `;
  }
}
